<template>
  <div class="page-container">
    <el-card class="mb-20">
      <app-filter :filter-list="table_filter" @search="search" />
    </el-card>
    <el-card>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getRolesList"
        :is-current-page="false"
        :expand="true"
        :expand-template="expandUsers"
        :table-props="table_props"
      />
    </el-card>
    <!-- 分配角色权限  -->
    <el-dialog
      title="分配角色权限"
      :visible.sync="dialog_config.is_show"
      width="500px"
    >
      <assignPermission
        v-if="dialog_config.is_show"
        :data="dialog_config.data"
        @comfirm="dialog_config.comfirm"
        @cancel="dialog_config.is_show = false"
      />
    </el-dialog>
    <!-- 分配角色游戏权限  -->
    <el-dialog v-bind="assign_games_config.props" :visible.sync="assign_games_config.is_show">
      <assignGamePermission
        v-if="assign_games_config.is_show"
        :raw-data="assign_games_config.raw_data"
        @confirm="confirmAssignGame"
        @cancel="assign_games_config.is_show = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import RolesResource from '@/api/roles';
const rolesResource = new RolesResource();
import RoleUsers from '@/views/system/role-manage/components/roleUsers';

export default {
  components: {
    'assignPermission': () => import('@/views/system/role-manage/components/assignPermission'),
    'assignGamePermission': () => import('@/views/system/role-manage/components/assignGamePermission'),
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      table_filter: require('./model/table-filter')(this),
      table_params: { name: '' },
      /** 搜索命中后需要自动展开的角色 ID */
      expanded_keys: [],
      dialog_config: {
        is_show: false,
        data: {},
        comfirm: () => {},
      },
      assign_games_config: {
        is_show: false,
        raw_data: {},
        props: {
          title: '分配角色游戏权限「不设置游戏权限时，即拥有全游戏权限」',
          width: '800px',
        },
      },
    };
  },
  computed: {
    /** 表格属性：0 个账号的角色隐藏展开按钮；搜索命中后自动展开对应角色 */
    table_props() {
      return {
        'row-class-name': this.getRowClassName,
        'expand-row-keys': this.expanded_keys,
      };
    },
  },
  methods: {
    /** 按用户搜索角色 */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.refer();
    },
    /** 已分配账号数为 0 的角色不展示展开按钮 */
    getRowClassName({ row }) {
      return Number(row.user_count) === 0 ? 'role-no-expand' : '';
    },
    getRolesList(params = {}) {
      const { name = '' } = params;
      // 未搜索时不传 name，避免请求里出现空参数
      const request_params = name ? { name } : {};
      return new Promise((resolve, reject) => {
        rolesResource
          .getRolesApi(request_params)
          .then(({ list }) => {
            const role_list = Array.isArray(list) ? list : [];
            resolve(role_list);
            // expand-row-keys 按表格当前 data 映射 key，必须等新数据渲染完成后再设置，否则会被覆盖
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.expanded_keys = name ? role_list.map(({ id }) => id) : [];
              });
            });
          }).catch(reject);
      });
    },
    assignPermission(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        data: row,
        comfirm: () => {
          this.$refs.table.refer();
          this.dialog_config.is_show = false;
        },
      });
    },
    /**
     * 打开分配游戏权限弹窗
     * @param {Record<string,any>} row 当前行数据
     */
    openAssignGamesDialog(row) {
      Object.assign(this.assign_games_config, { raw_data: row });
      this.assign_games_config.is_show = true;
    },
    /** 确认分配游戏权限 */
    confirmAssignGame() {
      this.$refs.table.refer();
      this.assign_games_config.is_show = false;
    },
    expandUsers(row) {
      // 列表接口已不再返回角色下的账号，展开二级列表时由子组件按角色 ID 单独请求
      return this.$createElement(RoleUsers, { props: { roleId: row.id }});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
// 已分配账号数为 0 的角色隐藏展开按钮
.page-container /deep/ .el-table__row.role-no-expand .el-table__expand-icon {
  visibility: hidden;
}
</style>
